export const styles = theme => ({
  root: {},
  label: {
    opacity: 0.6,
    color: theme.palette.colors.white,
    fontSize: theme.constants.fontSizes.small,
  },
});
